<template>
    <div class="subnav">
        <div class="subnav--list">
            <div class="subnav--list-item" v-for="(link, index) in links" v-bind:class="link.active ? 'active' : ''">
                <a v-on:mouseenter="hoverIndex = index" v-on:mouseleave="hoverIndex = null" class="subnav--list-item-link" :href="link.link">
                    <div class="subnav--list-item-image">
                        <svg-image
                            :src="'/svg/' + resource_group + '/' + link.icon"
                            width="20"
                            height="20"
                            :hover="hoverIndex === index || link.active"
                        />
                    </div>
                    <span class="subnav--list-item-label">{{link.label}}</span>
                </a>
            </div>
        </div>

        <div class="subnav--dropdown">
            <div class="dropdown">
                <a
                    id="subnav-dropdown-button"
                    href="#"
                    class="btn btn-sm btn-primary dropdown-toggle subnav--dropdown-button"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    <span class="subnav--dropdown-button-label">{{activeLabel}}</span>
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="subnav-dropdown-button">
                    <a
                        v-for="link in links"
                        class="subnav--dropdown-item-link"
                        v-bind:class="link.active ? 'active' : ''"
                        :href="link.link"
                    >
                        <div class="subnav--dropdown-item-image">
                            <svg-image
                                :src="'/svg/' + resource_group + '/' + link.icon"
                                width="20"
                                height="20"
                            />
                        </div>
                        <span class="subnav--dropdown-item-label">{{link.label}}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "Subnav",
        props: [
            'links',
            'activeLabel'
        ],
        data() {
		    return {
                hoverIndex: null
            }
        }
	}
</script>
